import { AnyAction } from 'redux';

import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';

import { ServicesActionTypes, ServicesState } from './services.types';

export const servicesInitialState: ServicesState = {};

export const servicesReducer: (state: ServicesState | undefined, action: AnyAction) => ServicesState = (
	state = servicesInitialState,
	action
): ServicesState => {
	if (action.type === ServicesActionTypes.saveSuccessServiceResponse) {
		return {
			...state,
			...action.payload,
		};
	} else if (action.type === ServicesActionTypes.saveErrorServiceResponse) {
		const error = action.payload.errors;
		return {
			...state,
			error: {
				code: error?.code,
				message: error?.message || TranslationHelper.t('general.genericError.title'),
			},
		};
	}

	return state;
};
